import { VesselDetails } from "../../../search-vessels/models/search.interfaces";
import { VesselCardVesselOption } from "../models/vessel-card.models";
import { getVesselCardPreferenceVessel } from "../services/vessel-card-preference.service";
import { useEffect, useState } from "react";

// Loads My Vessels assignment separately so it never delays the performance card.
// Cancels stale lookups when the vessel, identity, or access changes.
export const useVesselCardPreference = (selectedVessel: VesselCardVesselOption, userName: string, enabled: boolean) => {
  const { imo, vesselName } = selectedVessel;
  const [vessel, setVessel] = useState<VesselDetails | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    setVessel(null);
    setHasError(false);

    if (!enabled || !userName) {
      setIsLoading(false);

      return;
    }

    const controller = new AbortController();
    setIsLoading(true);

    getVesselCardPreferenceVessel({ imo, vesselName }, userName, controller.signal)
      .then((nextVessel) => {
        if (!controller.signal.aborted) {
          setVessel(nextVessel);
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          setHasError(true);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      });

    return () => controller.abort();
  }, [enabled, imo, retryCount, userName, vesselName]);

  return { vessel, isLoading, hasError, retry: () => setRetryCount((count) => count + 1) };
};
